// extracted by mini-css-extract-plugin
module.exports = {"evaluation":"Evaluation_evaluation_3amFG"};